import { render, staticRenderFns } from "./ContabilitaSoggettoAltriIndirizziModalEditComponent.vue?vue&type=template&id=602c8f5c"
import script from "./ContabilitaSoggettoAltriIndirizziModalEditComponent.vue?vue&type=script&lang=js"
export * from "./ContabilitaSoggettoAltriIndirizziModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports